import React, {FC, ReactElement} from "react";
import {Grid, Typography} from "@mui/material";
import {Trans, useTranslation} from "react-i18next";

interface IProps {

}

export const KnowledgeBaseInfo: FC<IProps> = (): ReactElement => {
    const {t} = useTranslation();
    return <>
        <Grid container spacing={0.5}>
            <Grid item xs={12}>
                <Typography variant="h6">
                    <Trans i18nKey="knowledge_base.header">Knowledge base</Trans>
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="subtitle1">
                    <Trans i18nKey="knowledge_base.sub_header">
                        We have a large number of articles covering different aspects of accounting in Estonia.
                    </Trans>
                </Typography>
            </Grid>
            <Grid item container xs={12} alignItems="center" spacing={1}>
                <Grid item>
                    <Typography variant="subtitle1">
                        <Trans i18nKey="knowledge_base.visit_knowledge_base">If have a question please check it out in our knowledge base</Trans>
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography variant="subtitle1">
                        <a href={t("knowledge_base.link", 'https://help.amsgroup.ee')} target="_blank" rel="noreferrer"><i><Trans i18nKey="knowledge_base.here">here</Trans></i></a>
                    </Typography>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="subtitle2">
                    <Trans i18nKey="knowledge_base.ask_advice">
                        If something is still not clear to you, please do not hesitate to contact us via the chat
                    </Trans>
                </Typography>
            </Grid>
        </Grid>
    </>
};